import { Panel, Flex } from 'components/box';
import { Heading } from 'components/typography';
import { useEffect, useRef, useState } from 'react';
import Button from 'components/button';
import { Link } from 'components/configurable-routing';
import { dateObjectToIso, dateIsoToObject } from '../../../../util/date';
import config from '../../../../util/load-config';
import { css } from '@emotion/react';
import { ClientOnly } from 'components/_shared/widgets/render-control';

const datesEqual = (date1: Date, date2: Date) => {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};

const isToday = (date1: Date) => {
  return datesEqual(date1, new Date());
};

const isTomorrow = (date1: Date) => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return datesEqual(date1, tomorrow);
};

const NotActive = ({
  isTimedOut,
  isEarly,
  activeFromDate,
}: {
  isTimedOut: boolean;
  isEarly: boolean;
  activeFromDate?: string;
}) => {
  const [comeBackWhen, setComeBackWhen] = useState('');

  useEffect(() => {
    if (!isEarly || !activeFromDate) {
      return;
    }

    const activeDate = dateIsoToObject(activeFromDate);

    if (isToday(activeDate)) {
      setComeBackWhen(
        `at ${activeDate.getHours() % 12 ? activeDate.getHours() % 12 : 12}${
          activeDate.getHours() > 11 ? 'pm' : 'am'
        }`
      );
    } else if (isTomorrow(activeDate)) {
      setComeBackWhen('tomorrow');
    } else {
      setComeBackWhen(dateObjectToIso(activeDate).split(' ')[0]);
    }
  }, [isEarly, activeFromDate, setComeBackWhen]);

  const expiredText = useRef(
    config.marketing.soldOutOverlay.expiredHeaders[
      Math.floor(
        Math.random() * config.marketing.soldOutOverlay.expiredHeaders.length
      )
    ]
  ).current;

  return (
    <Panel py={4}>
      <Flex alignItems="center" flexDirection="column">
        <ClientOnly>
          <Heading
            as="h3"
            fontSize="l"
            textAlign="center"
            css={css`
              text-transform: uppercase;
            `}
          >
            {isTimedOut ? (
              <>{expiredText}</>
            ) : (
              <>
                We love the enthusiasm,
                <br />
                but you&apos;re too early.
              </>
            )}
          </Heading>
        </ClientOnly>
        {isEarly && comeBackWhen && (
          <Heading as="h4" fontSize="m" mt={3} textAlign="center">
            Come back {comeBackWhen} to buy this product.
          </Heading>
        )}
        {isTimedOut && (
          <Heading as="h5" fontSize="m" mt={3} textAlign="center">
            This deal has expired!
          </Heading>
        )}
        <Heading as="h5" fontSize="m" mt={2} textAlign="center">
          {isTimedOut
            ? 'Subscribe to never miss a deal again.'
            : 'Want our deals in your inbox?'}
        </Heading>
        <Link
          href="https://link.onedayonly.co.za/join/6kh/signup"
          target="_blank"
        >
          <Button mt={4} px={4} size="small">
            Subscribe Now
          </Button>
        </Link>
      </Flex>
    </Panel>
  );
};

export default NotActive;
